var generateStyle = function generateStyle(componentTheme) {
  return {
    titleShowWrapper: {
      position: 'relative',
      width: '100%',
      height: '5rem',
      boxSizing: 'border-box',
      paddingLeft: componentTheme.titleShowWrapperLeftPadding,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  };
};
export default generateStyle;